import moment from 'moment-timezone';
import { MAX_OFFSET, TIME_FORMAT } from './Scheduler.constants';

const increment = 15;

export const getTimeOffsetOptions = (minuteOfDayString: string) => {
  const momentTime = moment(minuteOfDayString, TIME_FORMAT);

  const opts = [];

  for (let i = 0; i <= MAX_OFFSET; i += increment) {
    const option = {
      value: i,
      id: `${i}`,
      data: {
        startTime: minuteOfDayString, // used for updating options in BasicSelect when time value changes
      },
      ...(i === 0
        ? {
            label: `Start at exact time`,
            Suffix: momentTime.format(TIME_FORMAT),
          }
        : {
            label: `${i} minutes`,
            Suffix: momentTime.add(increment, 'm').format(TIME_FORMAT),
          }),
    };

    opts.push(option);
  }
  return opts;
};
